import React, { useEffect, useState } from 'react';
import SEO from './common/SEO';
import { Button } from './ui/button';

const APP_STORE_URL = 'https://apps.apple.com/us/app/diverplus-diving-app/id6504115639';

/**
 * If AASA verification hasn't kicked in yet (or the app isn't installed),
 * Safari lands here instead of the app opening via Universal Link. The
 * custom-scheme URL below reuses the same host/path the app's onOpenURL
 * handler already matches for trycurrents.app, so it routes through the
 * same magic-link completion code.
 */
const buildAppDeepLink = (): string => {
  const { search, hash } = window.location;
  return `currents://trycurrents.app/auth/magic-link${search}${hash}`;
};

const MagicLinkRedirect: React.FC = () => {
  const [attemptedAutoOpen, setAttemptedAutoOpen] = useState(false);

  useEffect(() => {
    window.location.href = buildAppDeepLink();
    setAttemptedAutoOpen(true);
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
      <SEO path="/auth/magic-link" title="Signing you in | Currents" description="Continue signing in to Currents." />
      <img src="/currents-logo.png" alt="Currents Logo" className="w-16 h-16 rounded-2xl shadow-lg mb-6" />
      <h1 className="text-2xl font-bold mb-2">Continue in the Currents app</h1>
      <p className="text-gray-600 mb-8 max-w-sm">
        {attemptedAutoOpen
          ? "If the app didn't open automatically, tap below to finish signing in."
          : 'Opening Currents…'}
      </p>
      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Button size="lg" onClick={() => { window.location.href = buildAppDeepLink(); }}>
          Open in Currents
        </Button>
        <Button size="lg" variant="outline" onClick={() => window.open(APP_STORE_URL, '_blank')}>
          Don&apos;t have the app? Get it on the App Store
        </Button>
      </div>
    </div>
  );
};

export default MagicLinkRedirect;
